export default {
  'billing.period.day': '{count} 天',
  'billing.period.week': '{count} 周',
  'billing.period.month': '{count} 个月',
  'billing.period.year': '{count} 年',
  'billing.period.purchase': '每期 {duration} × {count} 期',
  'billing.period.oneTime': '一次性购买',
  'billing.period.unavailable': '周期信息不可用',
};
